import React from 'react';
//import './Footer.css'; // Optional: if you want separate styles for the footer

function Footer() {
  return (
    <footer className="footer footer-brisi">
      {' '}
      Copyright © 2024 - OneTimeInbox.com{' '}
    </footer>
  );
}

export default Footer;
